import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './ProjectParameters.css';

export interface IProjectParametersProps {
  area?: string;
  floors?: string;
  materials?: string;
  hideOverflow?: boolean;
}

export const ProjectParameters: React.FC<IProjectParametersProps> = ({ area, floors, materials, hideOverflow }) => {
  return (
    <div className={clsx({ [styles['overflow']]: hideOverflow })}>
      {area && <span className={styles['item']}>{area}</span>}
      {floors && <span className={styles['item']}>{floors}</span>}
      {materials && <span className={styles['item']}>{materials}</span>}
    </div>
  );
};
